module.exports = __webpack_public_path__ + "static/media/splitCheckSecondScreen.a5fc9b03.png";